<template>
  <div class="outlined rounded-lg pt-4 pr-4 pl-4" style="border-color: #6B7280">
    <div class="row">
      <div class="col-sm-13" @click="hideDiv = !hideDiv">
        <h2 class="h5 mb-4">
          <i
            class="fa"
            v-bind:class="{
              'fa-angle-right': !hideDiv,
              'fa-angle-down': hideDiv
            }"
          ></i>
          Add a pickup time restriction
        </h2>
      </div>
      <div class="col-sm-11" v-show="hideDiv">
        <div class="form-check" style="display:inline-block">
          <label class="form-check-label" style="font-size: 1.1rem">
            <input
              type="checkbox"
              class="form-check-input"
              :checked="restriction"
              @change="$emit('restrictionToggled')"
            />
            Set a "before" time restriction
          </label>
        </div>

        <a-popover
          class="info float-right"
          width="400"
          visible-arrow="true"
          trigger="hover"
          placement="bottom"
        >
          <template slot="content">
            <div style="max-width:200px">
              Pickup time, We will pickup your freight after the time you
              specify and optionally before the end restriction time you
              specify.
            </div>
          </template>
          <i class="far fa-info-circle"></i>
        </a-popover>
      </div>
    </div>

    <div>
      <div class="row" v-show="hideDiv">
        <div class="col-sm-13">
          <label>After</label>
        </div>
        <div class="col-sm-11">
          <label>Before</label>
          <div
            v-if="errors.has('pickup_before_datetime')"
            style="display:block"
            class="invalid-feedback"
          >
            {{ errors.first("pickup_before_datetime") }}
          </div>
        </div>
      </div>

      <div class="form-row" v-show="hideDiv">
        <div class="form-group col-sm-4">
          <select
            class="form-control"
            v-model="after.time"
            :class="{ 'is-invalid': errors.has('pickup_after_time') }"
            name="pickup_after_time"
            v-validate="'required'"
          >
            <option v-for="(display, value) in hours" :value="value">{{
              display
            }}</option>
          </select>
          <div
            v-show="errors.has('pickup_after_time')"
            class="invalid-feedback"
          >
            Please enter a valid time
          </div>
        </div>
        <div class="form-group col-sm-9">
          <select
            class="form-control"
            v-model="after.date"
            :class="{ 'is-invalid': errors.has('pickup_after_date') }"
            name="pickup_after_date"
            v-validate="'required'"
          >
            <option v-for="(display, value) in days" :value="value">{{
              display
            }}</option>
          </select>
          <div
            v-show="errors.has('pickup_after_date')"
            class="invalid-feedback"
          >
            Please enter a valid date
          </div>
        </div>
        <div class="form-group col-sm-4">
          <select
            class="form-control"
            v-model="before.time"
            :disabled="!restriction"
            :class="{ 'is-invalid': errors.has('pickup_before_time') }"
            name="pickup_before_time"
            v-validate="'required'"
          >
            <option v-for="(display, value) in hours" :value="value">{{
              display
            }}</option>
          </select>
          <div
            v-show="errors.has('pickup_before_time')"
            class="invalid-feedback"
          >
            Please enter a valid time
          </div>
        </div>
        <div class="form-group col-sm-7 pb-4">
          <select
            class="form-control"
            v-model="before.date"
            :disabled="!restriction"
            :class="{ 'is-invalid': errors.has('pickup_before_date') }"
            name="pickup_before_date"
            v-validate="'required'"
          >
            <option v-for="(display, value) in days" :value="value">{{
              display
            }}</option>
          </select>
          <div
            v-show="errors.has('pickup_before_date')"
            class="invalid-feedback"
          >
            Please enter a valid date
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "pickup-time",
  props: ["after", "before", "restriction"],
  inject: ["$validator"],
  data() {
    return {
      hideDiv: false
    };
  },

  computed: {
    hours() {
      let hours = {};

      for (let i = 0; i < 24; i++) {
        hours[
          moment()
            .hours(i)
            .minutes(0)
            .format("HH:mm")
        ] = moment()
          .hours(i)
          .minutes(0)
          .format("h:mma");
      }

      return hours;
    },

    days() {
      const days = {};

      for (let i = 0; i < 24; i++) {
        if (i === 0) {
          days[
            moment()
              .add(i, "day")
              .format("YYYY-MM-DD")
          ] =
            "Today (" +
            moment()
              .add(i, "day")
              .format("ddd D MMM") +
            ")";
        } else if (i === 1) {
          days[
            moment()
              .add(i, "day")
              .format("YYYY-MM-DD")
          ] =
            "Tomorrow (" +
            moment()
              .add(i, "day")
              .format("ddd D MMM") +
            ")";
        } else {
          days[
            moment()
              .add(i, "day")
              .format("YYYY-MM-DD")
          ] = moment()
            .add(i, "day")
            .format("ddd D MMM");
        }
      }

      return days;
    }
  }
};
</script>
